import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { RoomType } from 'frontend-utils/models/roomtype';
import type { MealTypeValues } from 'lumen/utils/constants/general-constants';

type RoomTypeSetting = {
  id: RoomType;
  name: string;
};

export default class PaRatePreferenceOption extends Model {
  [Type] = 'pa-rate-preference-option' as const;

  @attr() declare channel: string[];
  @attr() declare los: number[];
  @attr() declare mealtype: MealTypeValues[];
  @attr() declare persons: number[];
  @attr() declare rateType: string[];
  @attr() declare roomType: RoomTypeSetting[];
  // Also used as id (primaryKey in the model serializer)
  @attr('number') declare subscriptionId: number;
}
